import { getGenreWhenMobile } from '@/pages/intelligence/services/globalView';

import type { IBaseResponse, IGenreRes } from '@intelligence/types/common';
import type { IGenreType } from '../types';

export function createFetchCascaderGenres(genreType: IGenreType): (params: any) => IBaseResponse<IGenreRes> {
  return async () => {
    const res = await getGenreWhenMobile({ genre_type: genreType });
    const resData = res?.data;
    const ieggGenres = resData?.ieg?.map((genre: any) => {
      const mainGenreValue = genre?.ieg_main;
      const mainGenre = {
        genre: mainGenreValue,
        genre_en: mainGenreValue,
        genre_cn: mainGenreValue,
      };
      const subGenres = genre?.ieg_sub_list?.map((subGenre: any) => {
        return {
          genre: subGenre,
          genre_en: subGenre,
          genre_cn: subGenre,
        };
      });
      return { main_genre: mainGenre, sub_genre: subGenres || [] };
    });
    return {
      ...res,
      data: {
        ieg: ieggGenres || [],
        annir: [],
      }
    };
  };
}
